module.exports = __webpack_public_path__ + "img/various-icon-g.82f972c3.png";